export default {
  component: () => import('./page.vue'),
  path: '/model/:serial',
  name: 'model',
  props: true,
  meta: {
    title: '身份模型',
    auth: true,
  },
};
